/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  //  apiUrl: 'http://163.53.85.48:7071/cogs',
  // apiUrl: 'http://localhost:7073' 
  // apiUrl: 'http://167.86.112.53:7077/cogs',


  // apiUrl:'https://api.postprop.in/testing_cogs',

  apiUrl: 'https://api.postprop.in/cogs_live',


};
